define(
    ['text!./templates/basler-email-dialog.html'],
    (emailDialogTemplate) => {

        return ['ModalService', 'qnb.EmailService', 'StateUtils', '$state', '$translate', 'LocaleService', 'ViewModelService', 'ContextService','$location',
            function (ModalService, QuoteEmailService, StateUtils, $state, $translate, LocaleService, ViewModelService, ContextService, $location) { // NOSONAR

                return {
                    restrict: 'A',
                    scope: {
                        /** Model (value) to select. */
                        quoteId: '=',
                        sessionId: '='
                    },
                    link: function (scope, element) { // NOSONAR
                        element.on('click', emailQuote);

                        /**
                         * Request a mail with the quote
                         * @param dialogScope scope of the dialog.
                         * @param emailInfo QuoteEmailDTO.
                         */
                        function sendMail(dialogScope, form) {

                            form.submitted = true;

                            if (!dialogScope.emailInfoView.emailAddress.aspects.subtreeValid) {
                                return;
                            }
                            if (!dialogScope.dataProcessingConfirmedView.aspects.subtreeValid) {
                                return;
                            }

                            QuoteEmailService.emailQuote('quoteandbind', dialogScope.emailInfoView.value)
                                .then(() => {
                                    dialogScope.$dismiss();
                                    ModalService.showInfo(
                                        'quoteandbind.directives.QnbWizardButtons.Quote Emailed',
                                        $translate(
                                            'quoteandbind.directives.QnbWizardButtons.Your quote details have been emailed',
                                            {emailAddress: dialogScope.emailInfoView.emailAddress.value}
                                        )
                                    );
                                })
                                .catch(() => {
                                    dialogScope.$dismiss();
                                    ModalService.showError(
                                        'quoteandbind.directives.QnbWizardButtons.Error',
                                        'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email you your details at this time.'
                                    );
                                });
                        }

                        function closeDialog(dialogScope) {
                            dialogScope.$dismiss()
                        }
                        function emailQuote() {
                            // Get an Email to preset the email field in the dialog. Either seller email of dealer or email of the account holder
                            const { draftData } = StateUtils.dataForState('baseQnbWizard').model;
                            const draftDataValue = draftData.value;
                            let presetEmail;

                            if (draftDataValue.partnerDetails && draftDataValue.partnerDetails.email) {
                                presetEmail = draftDataValue.partnerDetails.email;
                            } else if (draftDataValue.accountHolder.contact.emailAddress) {
                                presetEmail = draftDataValue.accountHolder.contact.emailAddress;
                            }

                            const emailInfo = {
                                quoteID: scope.quoteId,
                                sessionID: scope.sessionId,
                                language: LocaleService.getCurrentLocale(),
                                emailAddress: presetEmail,
                            };

                            draftData.dataProcessingConfirmed.value = ContextService.getDataProcessingConfirmed();
                            scope.data = {
                                dataProcessingConfirmedView: draftData.dataProcessingConfirmed,
                            };
                            scope.$watch('data.dataProcessingConfirmedView.value', (newValue, oldValue) => {
                                if (newValue !== oldValue) {
                                    ContextService.setDataProcessingConfirmed(newValue);
                                }
                            });
                            scope.data.emailInfoView = ViewModelService.create(
                                emailInfo,
                                'pc',
                                'edge.capabilities.quote.mailing.dto.QuoteEmailDTO'
                            );

                            ModalService.showSimpleDialog(emailDialogTemplate, scope.data, {
                                sendMail,
                                closeDialog
                            }, null);

                            element[0].focus();
                        }
                    },
                };
            }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerEmailOffer.js